/**
 * Chip redondeado con fondo suave.
 * Usa clases estáticas para que Tailwind JIT las incluya siempre.
 */
const styleMap = {
    /* WhatsApp */
    Conectado:    "bg-green-100 text-green-800",
    Desconectado: "bg-red-100 text-red-800",
  
    /* Estados genéricos (siguen disponibles) */
    Done:            "bg-green-100 text-green-800",
    Stuck:           "bg-red-100 text-red-800",
    "Working on it": "bg-working/20 text-working",
    Low:             "bg-low/20 text-low",
    Critical:        "bg-critical/20 text-critical",
  };
  
  export default function StatusPill({ label = "Done" }) {
    const classes = styleMap[label] ?? "bg-gray-100 text-gray-600";
    return (
      <span className={`px-3 py-0.5 rounded-full text-xs font-semibold ${classes}`}>
        {label}
      </span>
    );
  }
  